<template>
  <div
    class="draggable"
    ref="draggableContainer"
    :style="{ width: fill ? '100%' : 'max-content' }"
  >
    <!-- content -->
    <div
      class="draggable-source"
      ref="sourceEl"
      :style="{ width: fill ? '100%' : 'max-content' }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //   控制的对象
    controlEl: {
      default: (this.$refs && this.$refs.draggableContainer) || null,
    },
    fill: {
      default: false,
    },
  },
  data() {
    return {
      mousedown: false,
      //   mousehover: false,
      targetEl: null,
      ox: "",
      oy: "",
      x: 0,
      y: 0,
      delay:300
    };
  },
  watch: {
    controlEl(nv) {
      if (nv instanceof HTMLElement && this.targetEl !== this.controlEl) {
        let computedStyle = getComputedStyle(nv);
        if (!["absolute", "fixed"].includes(computedStyle["position"])) {
          nv.style.position = "absolute";
        }
        this.targetEl = this.controlEl;
        this.addListeners();
      }
    },
  },
  methods: {
    addListeners() {
      this.$nextTick(() => {
        let el = this.$refs.sourceEl;
        el.addEventListener("mousedown", this.mouseDown.bind(this));
        el.addEventListener("mousemove", this.divMouseMove.bind(this));
        el.addEventListener("mouseleave", this.mouseLeave.bind(this));
        // el.addEventListener("mouseup", this.mouseUp.bind(this));
      });

      //   el.addEventListener("mouseover");
    },
    mouseDown(e) {
      e.preventDefault();
      this.mousedown = true;
      this.ox = e.clientX;
      this.oy = e.clientY;
      // let rect = this.targetEl.getBoundingClientRect();
      let { top, left } = getComputedStyle(this.controlEl);
      this.x = parseInt(left);
      this.y = parseInt(top);
    },
    mouseLeave(e) {
      //修正鼠标过快以至于离开元素问题
      //   setTimeout(() => {
      // let tm = new Date().getTime();
      this.mouseMove(e);
      document.onmousemove = this.mouseMove.bind(this);
      setTimeout(()=>{
        this.removeDocumentMove()
      },this.delay)

      //   }, this.delay);
    },
    removeDocumentMove() {
      document.onmousemove = null;
      // if (document.onmousemove == this.mouseMove) {
      // }
    },
    divMouseMove(e) {
      this.removeDocumentMove();
      this.mouseMove(e);
    },
    // mouseUp(e) {
    //   //给一定的延迟防止移动太快
    //   let to = setTimeout(() => {
    //     this.mousedown = false;
    //   }, this.delay);
    // },
    mouseMove(e) {
      e.preventDefault();
      //   this.ox = e.clientX;
      //   this.oy = e.clientY;
      if (e.buttons > 0) {
        this.drag(e);
      }
    },
    drag(e) {
      let tel = this.targetEl;
      //   let rect = tel.getBoundingClientRect();
      let [dx, dy] = [e.clientX - this.ox, e.clientY - this.oy];
      [this.x, this.y] = [dx + this.x, dy + this.y];
      tel.style.left = `${this.x}px`;
      tel.style.top = `${this.y}px`;
      this.ox = e.clientX;
      this.oy = e.clientY;
    },
  },
  mounted() {
    // this.targetEl = this.controlEl || this.$refs.draggableContainer;
    // this.addListeners();
  },
  destroyed() {
    this.removeDocumentMove()
  },
};
</script>
<style lang="scss" scoped>
.draggable {
  width: max-content;
  height: max-content;
  .draggable-source {
    width: max-content;
    height: max-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup/Draggable.vue